
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Live'
})
export default class Live extends Vue {}
